// Purchase limits of a mix variant (`item`) or of a bundle.

export const get_mix_variant_limit_min = (item, bundle) => {
  if (bundle) {
    return 1;
  }
  return item?.details?.limit_min > 0 &&
    item?.details?.limit_min < item?.details?.count
    ? item?.details?.limit_min
    : 1;
};

export const get_mix_variant_limit_max = (item, bundle) => {
  if (bundle) {
    return bundle?.count;
  }
  if (item?.details?.limit_max > 0) {
    if (item?.details?.limit_max < item?.details?.count) {
      return item?.details?.limit_max;
    } else {
      return item?.details?.count;
    }
  } else if (item?.details?.limit_max === 0) {
    return 0;
  } else {
    return item?.details?.count;
  }
};
